import { isEmpty } from 'lodash/lang';
import moment from 'moment';

import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { COMMENT_NOT_SAVED } from '../../../../../constants/notificationMessages';

import { NOT_PERFORMED_DATE_FORMAT, ReviewType } from './reviewConstants';
const icons = {
  Table: 'table_chart',
  NewTable: 'table_chart',
  Logs: 'format_list_numbered',
  Procedure: 'medical_services',
  Reminder: 'alarm_on',
  Comments: 'forum',
  Custom: 'extension',
  Checklist: 'playlist_add_check',
  PatientStatus: 'contact_emergency',
  PatientStipend: 'monetization_on',
  Outreach: 'people_outline',
  ChartReview: 'bar_chart',
  ICF: 'description'
};
const iconsSuit = {
  Table: 'material-outline',
  NewTable: 'material-outline',
  Logs: 'material-outline',
  Procedure: 'material',
  Reminder: 'material-outline',
  Comments: 'material-outline',
  Custom: 'material-outline',
  Checklist: 'material-outline',
  PatientStatus: 'material',
  PatientStipend: 'material-outline',
  Outreach: 'material-outline',
  ChartReview: 'material-outline',
  ICF: 'material-outline'
};

export function getIcon(type) {
  return icons[type.replace(' ', '')];
}

export function getIconSuit(type) {
  return iconsSuit[type.replace(' ', '')];
}

export function logSnapshotReviewStateHasRecords(logSnapshotReviewState) {
  return !isEmpty(logSnapshotReviewState?.rows);
}

export function logCheckSnapshotReviewStateHasRecords(logCheckSnapshotReviewState) {
  return !isEmpty(logCheckSnapshotReviewState?.logCheckSnapshot?.logCheckAnswers);
}

export function itemGroupSnapshotReviewStateHasRecordsOrNotPerformed(itemGroupSnapshotReviewState) {
  return (
    !isEmpty(itemGroupSnapshotReviewState?.itemGroupSnapshotState.rows) ||
    itemGroupSnapshotReviewState?.itemGroupSnapshotState?.dataStatus?.notPerformed
  );
}

export function isSmReview(reviewType) {
  return reviewType === ReviewType.SM;
}

export function isPiReview(reviewType) {
  return reviewType === ReviewType.PI;
}

export function isSmOrPiReview(reviewType) {
  return isSmReview(reviewType) || isPiReview(reviewType);
}

export function getReviewType(route) {
  if (route.name === 'Study Manager Encounter Review') {
    return ReviewType.SM;
  }
  if (route.name === 'Investigator Encounter Review') {
    return ReviewType.PI;
  }
}

export function getFormattedDateForNotPerformedItemGroup(dateString) {
  return moment(dateString).format(NOT_PERFORMED_DATE_FORMAT);
}

export function handleReviewCommentExceptions(err) {
  if (err.response.status === 409) {
    NotificationManager.error(err.response.data.message);
  } else {
    NotificationManager.error(COMMENT_NOT_SAVED);
  }
  console.error(err);
}
